import { combineReducers } from 'redux';
import AppReducer from './App';
import UserDataReducer from './UserData';
import SectionReducer from './Section';

const rootReducer = combineReducers({
  app: AppReducer,
  userData: UserDataReducer,
  section: SectionReducer,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/Root.js